import update from 'immutability-helper';
import { filter, mapValues } from 'lodash-es';
import * as actionTypes from '../constants/actionTypes';
import * as status from '../constants/imagePreloading';
import * as contentStatus from '../constants/contentStatus';
export default function imagePreloading(state, action) {
    var _a, _b, _c;
    if (state === void 0) { state = {}; }
    if (action.type === actionTypes.LOAD_FULL_PROJECT_DONE ||
        action.type === actionTypes.SET_PROJECT) {
        var screens = action.project.screens;
        var changes_1 = {};
        filter(screens, isLoadable).forEach(function (_a) {
            var id = _a.id;
            var image = state[id];
            if (!image) {
                changes_1[id] = { $set: status.IDLE };
            }
        });
        return update(state, changes_1);
    }
    if (action.type === actionTypes.IMAGE_LOADING_START) {
        var id = action.id;
        return update(state, (_a = {},
            _a[id] = { $set: status.PRELOADING },
            _a));
    }
    if (action.type === actionTypes.RELOAD_IMAGES) {
        var currentScreenID_1 = action.currentScreenID;
        return mapValues(state, function (currentStatus, screenID) {
            // don't want to set status of RELOADING for current screen
            // and images that were not loaded yet
            return parseInt(screenID) === currentScreenID_1 || currentStatus !== status.DONE
                ? currentStatus
                : status.RELOADING;
        });
    }
    if (action.type === actionTypes.IMAGE_LOADED) {
        var id = action.id;
        return update(state, (_b = {},
            _b[id] = { $set: status.DONE },
            _b));
    }
    if (action.type === actionTypes.IMAGE_LOAD_FAILED) {
        var id = action.id;
        return update(state, (_c = {},
            _c[id] = { $set: status.ERROR },
            _c));
    }
    return state;
}
function isLoadable(screen) {
    return screen.contentStatus === contentStatus.IMAGE_UPLOAD_DONE;
}
